import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import TimeBreakInfoPopup from '../../jobDetails/WorkersTab/TimeBreakInfoPopup';
import { renderDateWithTimeZone } from '../../../../helpers/timezones';
import { timeFormatShort } from '../../../../constants/date';
import { workerBreakMinutesValues } from '../../../../constants/jobs';
import { parseHoursMinutes } from '../../../../helpers/jobs';
import UsersService from '../../../../services/UsersService';
import { getWorkerPayrollDate } from '../../../../helpers/workers';

export default class JobWorkerTimeline extends PureComponent {
  _renderTooltip = () => {
    if (!this.props.job_start_time) {
      return null;
    }

    const { job_start_time, time_zone_id, job_end_time, break_time } = this.props;
    const workerStartTimeString = renderDateWithTimeZone(job_start_time, timeFormatShort, time_zone_id);
    const workerEndTimeString = renderDateWithTimeZone(job_end_time, timeFormatShort, time_zone_id);
    const workerBreakOptions = break_time ? workerBreakMinutesValues.find(item => item.value === break_time * 60) : null;

    return (
      <TimeBreakInfoPopup
        workerStartTime={workerStartTimeString}
        workerEndTime={workerEndTimeString}
        workerBreak={workerBreakOptions ? workerBreakOptions.label : null}
      />
    );
  };

  render () {
    const { job_start_time, actual_hours, payroll_date } = this.props;

    const actualHoursValues = parseHoursMinutes(actual_hours);
    const hours = actualHoursValues.hours;
    const minutesUI = actualHoursValues.minutesUI;

    return (
      <div className={`d-inline-block ${job_start_time ? 'pointer' : ''}`}>
        <div className='position-relative hours-popup info-hours-popup job-worker-timeline'>
          <p className='d-flex align-center justify-content-center justify-content-md-start'>
            <span className='icon-wrapper icon-muted'><FontAwesomeIcon icon={faClock} /></span>
            { hours } hours { minutesUI } min
          </p>
          {this._renderTooltip()}
        </div>
        {!!payroll_date && UsersService.isAdmin() && (
          <p className='worker-info-row'>Payroll Date: {getWorkerPayrollDate(payroll_date)}</p>
        )}
      </div>
    );
  }
}

JobWorkerTimeline.propTypes = {
  job_start_time: PropTypes.string,
  time_zone_id: PropTypes.string,
  job_end_time: PropTypes.string,
  break_time: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object
  ]),
  actual_hours: PropTypes.number,
  payroll_date: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/app/jobsList/JobInfoWorker/JobWorkerTimeline.js